/**
 * Balloon letters — authored via the `/pack` toile process (plan
 * `thinking/plans/2026_08_31_toile_pack_wiring.md` Track B), wave `toile_lettering`. Narcis file-split
 * shape (Track A): one module per pack, `registry.ts` assembles them into `livePacks`.
 */
import {tagline, chips, type ToilePack} from './data'

export const balloonLettersPack: ToilePack = {
    slug: 'balloon-letters',
    category: 'illustration',
    name: 'Balloon letters',
    tagline: tagline('pieces', 'themes', 'styles'),
    chips: chips('themes', 'styles'),
    ratio: {w: 1216, h: 832},
    readings: [
        {key: 'birthday', label: 'Birthday word', subject: 'the word "PARTY" as glossy inflated foil balloon letters, each with a bright highlight and a curled ribbon string below'},
        {key: 'number', label: 'Age number', subject: 'a large balloon number "18" in shiny foil with a crimped seam around the edge and confetti around it'},
        {key: 'name', label: 'A name', subject: 'the name "Mia" in puffy pastel balloon letters tied together by one ribbon, small hearts floating above'},
    ],
    styles: [
        {key: 'glossy', label: 'Glossy', style: 'glossy vector balloons with crisp white highlight shapes and smooth gradient-free fills', palette: 'Shiny red, gold and blue on a soft gray background.', framing: 'The balloons are centered with a generous margin.'},
        {key: 'pastel', label: 'Pastel', style: 'soft matte balloons in rounded flat shapes with one small highlight each', palette: 'Pastel pink, lilac and mint on a cream background.', framing: 'The balloons are centered with an even margin.'},
        {key: 'sticker', label: 'Die-cut sticker', style: 'a die-cut sticker with a thick white border around the whole shape and a faint glossy sheen', palette: 'A bright palette of five colors on a plain light blue background.', framing: 'The sticker is centered, well inside the frame.'},
    ],
    directions: ['gold and white', 'rainbow', 'a heart'],
    directionHint: 'try: gold and white',
    seo: {
        title: 'Balloon Letters: Party Word, Age Number, First Name',
        metaDescription: 'Nine balloon letter designs: a party word, an age number and a first name in glossy, pastel and sticker styles.',
        h1: 'Balloon letters: a party word, an age number, a first name',
        tagline: 'Words, numbers and names inflated into balloons, in three finishes.',
        intro: 'Balloon letters are letters drawn as shiny inflated balloons for birthday signs, invitations and party banners. The nine pieces show the word PARTY in glossy foil, a balloon number 18 with a crimped seam, and the name Mia in pastel balloons tied with one ribbon. Each comes as a glossy vector finish, a soft matte pastel, or a die-cut sticker. Ask for gold and white, rainbow or a heart.',
        useCases: [
            'a birthday sign',
            'an invitation header',
            'a party banner',
            'a balloon sticker for a party favor',
        ],
        faq: [
            {q: 'Which number is shown?', a: 'The sample is 18. Ask for another number and it is drawn as balloons in the same finish.'},
            {q: 'What is the difference between glossy and pastel?', a: 'Glossy has crisp white highlights and smooth fills. Pastel has soft matte balloons, each with one small highlight.'},
            {q: 'Can I get my own name on the balloons?', a: 'Yes. The name sample is Mia. A different name is a request, and its letters are drawn as balloons.'},
            {q: 'Is there a string?', a: 'The name sample has its balloons tied together by one ribbon.'},
        ],
    },
}
